var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFileText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.516,
    height: 11.516,
    viewBox: "0 0 11.516 11.516",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-paper",
    "data-name": "Icon ionic-ios-paper",
    d: "M5.479,4.261v8.914a.389.389,0,0,1-.388.388h0a.389.389,0,0,1-.388-.388V5.147H4.261a.885.885,0,0,0-.886.886V14a.885.885,0,0,0,.886.886h9.774a.856.856,0,0,0,.855-.855V4.261A.885.885,0,0,0,14,3.375l-7.7.055A.793.793,0,0,0,5.479,4.261Zm1.827.886H9.631a.389.389,0,0,1,.388.388h0a.389.389,0,0,1-.388.388H7.306a.389.389,0,0,1-.388-.388h0A.389.389,0,0,1,7.306,5.147Zm0,4.429h4.1a.389.389,0,0,1,.388.388h0a.389.389,0,0,1-.388.388h-4.1a.389.389,0,0,1-.388-.388h0A.389.389,0,0,1,7.306,9.576Zm5.426,2.99H7.306a.389.389,0,0,1-.388-.388h0a.389.389,0,0,1,.388-.388h5.426a.389.389,0,0,1,.388.388h0A.389.389,0,0,1,12.731,12.565Zm0-4.429H7.306a.389.389,0,0,1-.388-.388h0a.389.389,0,0,1,.388-.388h5.426a.389.389,0,0,1,.388.388h0A.389.389,0,0,1,12.731,8.136Z",
    transform: "translate(-3.375 -3.375)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileText);
export default __webpack_public_path__ + "static/media/icon-file-text.720fe9ce111f1449f6586787672dd050.svg";
export { ForwardRef as ReactComponent };